// MLAP-FILTER MLAP-1: ONE filter state → ONE request body for both look-ahead panes
// (backlog grid + Task Focus Gantt). Neither pane derives its own filter (L1/L2), and the
// server receives exactly the selected ids: N distinct numeric resourceIds, verbatim.
// An empty selection is "no resource filter" (DEC-4), not "show nothing".
//
// It is also the ONE place the current filter set is published: every look-ahead reload
// (page effect, period change inside the Gantt, manual REFRESH on either pane) reads the
// same state, so no pane derives its own (L1/L2).

const toIdList = (ids) => {
  if (!Array.isArray(ids)) return [];
  const out = [];
  const seen = new Set();
  ids.forEach((raw) => {
    if (raw == null || raw === "") return;
    // Resource ids are numeric; anything else cannot name a resource and is dropped at this
    // boundary rather than sent (a non-numeric id would only turn into a 400 → refusal).
    const id = typeof raw === "number" ? raw : /^\s*\d+\s*$/.test(String(raw)) ? Number(raw) : NaN;
    if (!Number.isFinite(id) || seen.has(id)) return;
    seen.add(id);
    out.push(id);
  });
  return out;
};

export const buildLookAheadFilters = (dates = {}, projectNames, resourceIds) => ({
  start: dates.start,
  finish: dates.finish,
  projectNames: Array.isArray(projectNames) ? [...projectNames] : [],
  resourceIds: toIdList(resourceIds),
});

export default buildLookAheadFilters;

let currentLookAheadFilters = null;

/** Publish the page's current filter set; every reload on either pane reads it. */
export const setCurrentLookAheadFilters = (filters) => {
  currentLookAheadFilters = filters;
};

/** The page's current filter set, or `fallback` before the page published one. */
export const getCurrentLookAheadFilters = (fallback) =>
  currentLookAheadFilters || fallback;
